export default {
    _prefix: "CalibrationSettings",
    labels: {
        calibrationCheckBox: "Use as Scoring Index for Calibration",
        createCalibration: "Create Calibration",
        evaluatorPlaceholderText:
            "Search and Select One or More Quality Evaluators",
        users: "users",
        qualityEvaluatorSelection: "Calibration Evaluator Selection",
    },
    errors: {
        noSelectedUsers: "There must be at least one selected user.",
        evaluatorsCantScore: (data: { userName: string }) =>
            "{{userName}} does not have permission to score evaluations for this conversation.",
    },
};
